// Modern JSX transform - React import not needed
import { memo } from 'react'
import { trackSpotModeEntitySelected, trackSpotModeEntityCreated } from '../../utils/analytics'

/**
 * EntitySearchDropdown - Search dropdown for entity selection in spot mode
 * Shows existing entities and "create new" option
 * 
 * @component
 * @example
 * <EntitySearchDropdown
 *   t={t}
 *   searchQuery="taco"
 *   searchResults={[{id: 1, name: "Taco Truck", scientificName: null}]}
 *   onSelectEntity={(entity) => setSpotModeEntity(entity)}
 *   onClose={() => setShowDropdown(false)}
 * />
 */
const EntitySearchDropdown = memo(function EntitySearchDropdown({
  t,
  searchQuery,
  searchResults = [],
  onSelectEntity,
  onCreateNew,
  onClose,
  spotModeEntityType
}) {
  const handleSelect = (entity, index) => {
    // Track entity selection
    trackSpotModeEntitySelected(
      searchResults.indexOf(entity),
      searchQuery,
      searchResults.length,
      spotModeEntityType
    )
    onSelectEntity(entity)
    onClose()
  }

  const handleCreateNew = () => {
    // Track new entity creation
    trackSpotModeEntityCreated(
      spotModeEntityType,
      searchQuery,
      searchResults.length > 0
    )
    onCreateNew({ name: searchQuery })
    onClose()
  }

  return (
    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
      {/* Existing entities */}
      {searchResults.length > 0 && (
        <>
          {searchResults.map((entity, index) => (
            <button
              key={entity.id}
              onClick={() => handleSelect(entity, index)}
              className="w-full px-4 py-2 text-left hover:bg-gray-100 border-b border-gray-100"
            >
              <div className="font-medium">{entity.name}</div>
              {entity.scientificName && (
                <div className="text-sm text-gray-600 italic">
                  {entity.scientificName}
                </div>
              )}
            </button>
          ))}
        </>
      )}
      
      {/* Always show "Use as new entry" option */}
      <button
        onClick={handleCreateNew}
        className="w-full px-4 py-3 text-left hover:bg-primary-50 text-primary-700 font-medium border-t-2 border-primary-200"
      >
        <div className="flex items-center gap-2">
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          <span>
            {searchResults.length > 0
              ? `Or use "${searchQuery}" as new entry`
              : `Use "${searchQuery}" as new entry`}
          </span>
        </div>
      </button>
    </div>
  )
})

export default EntitySearchDropdown
